import MenuConfig from "./MenuConfig";
import { MenuInterface } from './MenuItem';

interface MenuConfigTypes {
  anchorEl: HTMLElement;
  handleMenuClose: () => void;
  listMenu: MenuInterface[];
}
  
  const MenuConfigStandard = (props: MenuConfigTypes) => {
    
    let listMenu: MenuInterface[] = props.listMenu;

    return (
        <MenuConfig
            listMenu={listMenu}
            anchorEl={props.anchorEl}
            handleMenuClose={props.handleMenuClose}
        />
    )
  }

  export default MenuConfigStandard;